import React from 'react';
import cl from './Logos.module.css';
import useReveal from '../../hooks/useReveal';

// Полоса «нам доверяют» — собирательные образы детских центров.
// На старте у нас нет реальных клиентов, поэтому показываем образы
// типичных центров: «Кодик», «КодШкола», «IT-Старт», «РобоКлуб», «КиберДети».
const centres = [
    { name: 'Кодик', city: 'Москва',      color: '#3b82f6', initials: 'К' },
    { name: 'КодШкола', city: 'Казань',   color: '#10b981', initials: 'КШ' },
    { name: 'IT-Старт', city: 'Краснодар',color: '#a855f7', initials: 'IT' },
    { name: 'РобоКлуб', city: 'Самара',   color: '#ef4444', initials: 'РК' },
    { name: 'КиберДети',city: 'Новосибирск',color: '#f59e0b', initials: 'КД' },
];

export default function Logos() {
    // Для мобильного marquee дублируем массив дважды:
    // ползунок анимируется на -50% и петля выглядит бесшовной.
    const renderItem = (c, key) => (
        <div key={key} className={cl.item}>
            <div className={cl.mark} style={{ background: c.color }}>
                {c.initials}
            </div>
            <div className={cl.name}>{c.name}</div>
            <div className={cl.city}>{c.city}</div>
        </div>
    );

    const revealRef = useReveal();
    return (
        <section className={cl.logos} ref={revealRef}>
            <div className={cl.inner}>
                <div className={cl.label} data-reveal="up">
                    Подходит детским центрам по всей России
                </div>

                {/* Сетка на десктопе */}
                <div className={cl.grid} data-reveal-stagger>
                    {centres.map(c => renderItem(c, c.name))}
                </div>

                {/* Бесконечная лента на мобилке */}
                <div className={cl.marquee} aria-hidden="true" data-reveal="zoom">
                    <div className={cl.marqueeTrack}>
                        {centres.map(c => renderItem(c, 'a-' + c.name))}
                        {centres.map(c => renderItem(c, 'b-' + c.name))}
                    </div>
                </div>
            </div>
        </section>
    );
}
